import { CreateElement } from 'vue'
import { RouteConfig, Route } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { authPermissionPermissions as Permissions } from '@/helpers/enums/permission-models'
import * as TYPES from '@/helpers/enums/view-types'
import { PERMISSIONS_INFOMODELS_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as MENU_PERMISSIONS_INFOMODELS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'permissions/info-models',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "permissions.info-models.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'view-permissions-info-models-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: Permissions.read,
        },
        component: (): PromiseVue => import(
          /* webpackChunkName: "permissions.info-models.list" */
          './PermissionsInfoModelsList.vue'
        ),
      },
      {
        path: ':id(\\d+)',
        name: ROUTES.VIEW,
        meta: {
          permission: Permissions.read,
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.VIEW }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "permissions.info-models.view" */
          './PermissionsInfoModelsView.vue'
        ),
      },
      {
        path: ':id(\\d+)/edit',
        name: ROUTES.EDIT,
        meta: {
          permission: Permissions.edit,
        },
        props: ({ params: p }: Route) => ({ ...p, viewType: TYPES.EDIT }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "permissions.info-models.view" */
          './PermissionsInfoModelsView.vue'
        ),
      },
      {
        path: 'create',
        name: ROUTES.CREATE,
        meta: {
          permission: Permissions.create,
        },
        props: () => ({ viewType: TYPES.CREATE }),
        component: (): PromiseVue => import(
          /* webpackChunkName: "permissions.info-models.view" */
          './PermissionsInfoModelsView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
